import { CORE_ROUTE } from "@obg/ngx.core";

export const ACCOUNT_LIMIT_WARNING_ID = "ACCOUNT_LIMIT_WARNING";
export const EXPIRED_DOCUMENTS_WARNING_ID = "EXPIRED_DOCUMENTS_WARNING";
export const EXPIRED_DOCUMENTS_WARNING_TITLE = "kyc-verify-popup.existing-kyc-verify-account-limited";
export const ACCOUNT_WILL_BE_LIMITED_WARNING_TITLE = "kyc-verify-popup.existing-kyc-verify-documents-expired";
export const EXPIRED_DOCUMENTS_ICON = "common.alert-notification-icon";
export const EXPIRED_DOCUMENTS_ALERT_MESSAGE = "kyc-verify-popup.existing-kyc-verify-upload-new-doc";
export const EXPIRED_DOCUMENTS_VERIFY_BUTTON = "kyc-verify-popup.existing-kyc-verify-my-document";

export const TAX_POPUP_FLAG = "peru_tax_popup";
export const TAX_POPUP_SHOW_LIMIT = 4;

export const enum DocumentExpiredDaysLeft {
	DOCUMENTS_EXPIRED = 5,
}

export const REGISTRATIONSUCCESSROUTES = [
	CORE_ROUTE.registration.register,
	CORE_ROUTE.registration.manualRegister,
	CORE_ROUTE.registration.SPIDConfirmation,
	CORE_ROUTE.auth.login,
];

export const LAST_LOGIN_ALERT_FEATURE_FLAG_KEY = "last_login_alert";
